import { render, staticRenderFns } from "./app-loader-cmp.vue?vue&type=template&id=05bc68d4&scoped=true"
import script from "./app-loader-cmp.vue?vue&type=script&lang=js"
export * from "./app-loader-cmp.vue?vue&type=script&lang=js"
import style0 from "./app-loader-cmp.vue?vue&type=style&index=0&id=05bc68d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bc68d4",
  null
  
)

export default component.exports